
import { useParams } from 'react-router-dom';
import { VisitasFormState } from '../../../context/visitas/VisitasFormState';
import { Form } from './form';

export const VisitasFormPage = () => {
  const { id } = useParams();
  const title = id ? "Editar Visita" : "Crear Visita";
  return (
    <VisitasFormState>
        <br />
        <Form title={title} />
    </VisitasFormState>
  );
};
